import React,{Component} from 'react';
import Logo from '../../../images/logo-black.png';
import Image from '../../../images/product.png';
import Width from '../../../images/width.png';
import Height from '../../../images/height.png';
import Length from '../../../images/length.png';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SimpleReactValidator from 'simple-react-validator';
import templateId from '../../../libraries/lang-id';
import language from '../../../libraries/label-lang';
import {history} from '../../../shared/configure-store';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import Copyright from '../../presentational/copyright';
import {toast, ToastContainer} from 'react-toastify';
import Api from '../../../libraries/api';
import AddIcon from '@material-ui/icons/Add';
import {connect} from "react-redux";
import {RootActions} from "../../../shared/root-action";
import {bindActionCreators} from "redux";
import AuthHelper from "../../../libraries/auth-helper";
import NumberFormat from 'react-number-format';

SimpleReactValidator.addLocale('indo', templateId);


class Landing extends Component {


    componentDidMount(){

        document.title = 'Fresh Factory - Pengiriman';
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='main'>
                <section>
                    <div className='container reservation'>
                        <div className='row justify-content-center'>
                            <div className='col-md-10 col-lg-8 text-center'>
                                <img src={Logo} alt='logo' className='img-logo' />
                                <div className='row mx-auto'>
                                    <div className='col-md-4'>
                                        <img src={Image} alt='logo' className='mb-2' />
                                    </div>
                                    <div className='col-md-8 text-md-left'>
                                        <h2 className='text-big'>{text.reservation_welcome}!</h2>
                                        <p className='mb-0 color-brow n-grey'>{text.landing_paragraph}</p>
                                    </div>
                                </div>
                                <div className='underline pt-3'> </div>

                            </div>

                        </div>
                    </div>
                </section>

                <ToastContainer autoClose={false} />
                <footer>
                    <p className='text-center'><Copyright /></p>
                </footer>
            </main>
        )

    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);